export default "__VITE_ASSET__BwVUMPVC__"